<template>
  <div id="uploadImg">
    <el-upload
      action
      :multiple="false"
      :limit="limit"
      :http-request="uploadToOss"
      :file-list="fileList"
      :on-exceed="handleExceed"
      :on-preview="handlePictureCardPreview"
      :before-remove="beforeRemove"
      ref="img-upload"
      drag
      :before-upload="beforeUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">{{ title }}</div>
    </el-upload>

    <!-- dialog -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss";

const client = new OSS({
  region: "oss-cn-shanghai",
  accessKeyId: "LTAI5t7G2vewd5AFxHqGb6i6",
  accessKeySecret: "hvgW7uyYhmdw55Mlej1vrnaLZ4U8w3",
  bucket: "yz-ai-replacement",
});

export default {
  name: "uploadImg",
  props: {
    photoUrl: String,
    title: "",
    valueKey: "",
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [], //name,url
      limit: 1,
    };
  },
  watch: {
    photoUrl: {
      handler(newVal) {
        if (newVal) {
          this.fileList = [
            {
              name: genFileName(newVal),
              url: newVal,
            },
          ];

          function genFileName(newVal) {
            let str = newVal.split("aliyuncs.com")[1],
              nameStrArr = str.split("/");
            return decodeURI(nameStrArr[nameStrArr.length - 1]);
          }
        }
      },
      immediate: true,
      deep: false,
    },
  },
  methods: {
    // 校验图片格式
    beforeUpload(file) {
      let size = file.size / (1024 * 1024);
      if (!file) {
        return false;
      } else if (size > 20) {
        this.$message.error("请上传小于20MB的图片");
        return false;
      }
      // let result = this.verifyPhotoWH(file);
      // else if(){}
      // else if (!/\.(png|jpg)$/.test(file.name.toLowerCase())) {
      //   // 格式根据自己需求定义
      //   this.$message.error("上传格式不正确，请上传png/jpg格式");
      //   return false;
      // }
    },

    verifyPhotoWH(file) {
      let width = 1121;
      let height = 532;
      let _URL = window.URL || window.webkitURL;
      let image = new Image();
      image.onload = function () {
        let valid = image.width <= width && image.height <= height;
      };
      image.src = _URL.createObjectURL(file);
    },

    // 上传文件到oss
    uploadToOss(e) {
      let file = e.file; // 文件信息
      client
        .multipartUpload(`/templates/${file.name}`, file)
        .then((result) => {
          let url = result.res.requestUrls[0].split("?uploadId")[0];
          url = url.replace("http", "https");
          let fileObj = {
            name: file.name,
            url: url,
          };
          this.fileList = [fileObj];
          this.$emit("get-photo", fileObj);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 文件超出个数限制
    handleExceed(files, fileList) {
      this.$message.warning("只能上传一张banner图");
    },

    // 预览图片
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },

    // 下载图片
    handleDownload(file) {
      console.log(file);
    },

    // 删除图片
    beforeRemove(file, fileList) {
      this.fileList = [];
      this.$emit("delete-photo", { key: this.valueKey });
    },
  },
};
</script>
<style lang="scss" scoped>
// #uploadImg {
//   /deep/ .el-upload-list {
//     width: 70%;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/components/common/upload/uploadAIImg.vue